import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../store';
import { CalendarScaleType, ItemTaskType, ItemType } from '../types';
import { useRouting } from './routingProvider';

export const useSharedUrlParams = () => {
    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);

    const currentTask = useSelector<RootState, ItemTaskType | null>((state) => state.calendar.currentTask);
    const scheduleScale = useSelector<RootState, CalendarScaleType>((state) => state.calendar.scheduleScale);
    const currentDate = useSelector<RootState, string>((state) => state.calendar.currentDate);

    const { setUrlParam } = useRouting();
    useEffect(() => {
        setUrlParam({
            item: currentGantItem?.id,
            task: currentTask?.id,
            cldd: currentDate,
            clds: scheduleScale,
        });
    }, [currentGantItem, currentTask, currentDate, scheduleScale]);
};
